
<div id="preloader">
	<div class="jumper">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>  
<!-- ***** Preloader End ***** -->

<!-- Header removed: global header is now provided by <app-header> -->

<!--The content below is only a placeholder and can be replaced.-->
<noscript><h2 style="color: #ff0000">Seems your browser doesn't support Javascript! Websocket relies on Javascript being
		enabled. Please enable
		Javascript and reload this page!</h2></noscript>
<div id="main-content" class="container py-4">
	<div class="row mb-3">
		<div class="col-12">
			<h3>Notifications</h3>
			<p class="text-muted">Real-time updates and messages from the server.</p>
		</div>
	</div>

	<div class="row mb-3">
		<div class="col-md-6 mb-2">
			<div class="card p-3">
				<div class="d-flex align-items-center justify-content-between">
					<div>
						<strong>WebSocket</strong>
						<div class="text-muted small">Connection controls</div>
					</div>
					<div class="btn-group">
						<button (click)="connect()" class="btn btn-sm btn-success" type="button">Connect</button>
						<button (click)="disconnect()" class="btn btn-sm btn-danger" type="button">Disconnect</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-6 mb-2">
			<div class="card p-3">
				<div class="d-flex align-items-center justify-content-between">
					<div>
						<strong>Send Message</strong>
						<div class="text-muted small">Send a test message</div>
					</div>
					<div class="input-group" style="max-width:320px">
						<input type="text" [(ngModel)]="name" class="form-control" name="notifName" placeholder="Your name">
						<div class="input-group-append">
							<button (click)="sendMessage()" class="btn btn-primary" type="button">Send</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-md-8">
			<div id="inbox-list">
				<div *ngFor="let n of notifications" class="card mb-2 notif-card">
					<div class="card-body">
						<div class="d-flex justify-content-between">
							<div>
								<h6 class="mb-1">{{ n.title || 'Notification' }}</h6>
								<p class="mb-0 text-muted small">{{ n.body || n.message }}</p>
							</div>
							<div class="text-muted small">{{ n.time | date:'short' }}</div>
						</div>
					</div>
				</div>
				<div *ngIf="!notifications || notifications.length === 0" class="text-muted mt-2">No notifications yet.</div>
			</div>
		</div>
	</div>

</div>
<router-outlet></router-outlet>
  